import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WriteBody from '@calendar/components/Write/WriteBody.vue'
import RecipientFields from '@/components/common/RecipientFields.vue'
import * as dateutil from '@/util/date-helper'
import { mapMutations } from 'vuex';
import * as types from '@calendar/store/types'
@Component({
    components: {
        WriteBody,
        RecipientFields
    },
    methods: {
        ...mapMutations({
            setCurrentItem: types.CURRENT_CALENDAR_ITEM
        })
    }
})
export default class WriteForm extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) value!: calendar.CalendarItem;
    @Prop({ type: Object }) email!: mail.WriteEmailData;
    @Prop({ type: String }) folderName!: string;
    @Prop({ type: Object }) selectConference!: any;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentItem!: (item: calendar.CalendarItem) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    showWeekText: any

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get startDateText() {
        return dateutil.uGetDateFormat('yyyy-mm-dd', dateutil.IEDate(this.value.start)); 
    }

    get endDateText() {
        return dateutil.uGetDateFormat('yyyy-mm-dd', dateutil.IEDate(this.value.end)); 
    }

    get reminderText() {
        var number = this.value.reminderMinutesBeforeStart || 0
        if(number === 60) {
            return this.$t('N시간_전_알림', {number: 1}).toString()
        }
        else if(number === 1440) {
            return this.$t('N일_전_알림', {number: 1}).toString()
        }
        else if(number === 2880) {
            return this.$t('N일_전_알림', {number: 2}).toString()
        }
        else if(number === 4320) {
            return this.$t('N일_전_알림', {number: 3}).toString()
        }
        else if(number < 60) {
            return this.$t('N분_전_알림', {number: number}).toString()
        }
    }

    /**
     * 반복일정 설정 내용을 표시합니다
     */
     get getRecurrencePatternDisplay() {
        let beautifyStartTime
        let beautifyEndTime

        if (this.value.starttime && this.value.starttime.length > 3) {
            beautifyStartTime = this.value.starttime.substr(0, this.value.starttime.length - 3)
        }
        if (this.value.endtime && this.value.endtime.length > 3) {
            beautifyEndTime = this.value.endtime.substr(0, this.value.endtime.length - 3)
        }

        let display: string = ''
        //ex) 기간 3일 : 3.00:00:00 -> 3
        let scheduleDuration = this.value.scheduleDuration.split('.')[0]

        if (
            false &&
            this.value.isRecurring.toString() === 'False' &&
            this.value.appointmentType != 'RecurringMaster'
        ) {
            return (display = this.value.pidLidRecurrencePattern)
        }

        if (
            (this.value.isRecurring &&this.value.isRecurring.toString() === 'True') ||
            this.value.appointmentType == 'RecurringMaster'
        ) {
            if (this.value.appointmentType == 'Occurrence' || this.value.appointmentType == 'Exception') {
                display = this.value.pidLidRecurrencePattern
            }
            //'전체약속'
            else {
                let beautifyStartDate = this.value.recurrence.startDate.split('T')[0]
                let beautifyEndDate
                if (this.value.recurrence.endDate != null) {
                    beautifyEndDate = this.value.recurrence.endDate.split('T')[0]
                }
                //매일
                if (this.value.recurrence.ui_recurringType == 1) {
                    if (this.value.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매 ${this.value.recurrence.interval}일씩 주기로 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매 ${this.value.recurrence.interval}일씩 주기로 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매주
                else if (this.value.recurrence.ui_recurringType == 2) {
                    let weeklist = dateutil.uGetWeekArray([
                        this.$t('W_Schedule_Sunday').toString(),
                        this.$t('W_Schedule_Monday').toString(),
                        this.$t('W_Schedule_Tuesday').toString(),
                        this.$t('W_Schedule_Wednesday').toString(),
                        this.$t('W_Schedule_Thursday').toString(),
                        this.$t('W_Schedule_Friday').toString(),
                        this.$t('W_Schedule_Saturday').toString(),
                    ])
                // 반복일정 수정할 때 요일 체크한거 화면에 display
                let weekArrayString = weeklist
                    .filter((x: any) => this.value.recurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)
                    .map((x) => {
                    return x.text
                    })
                    .join(',')
                    if (this.value.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매${this.value.recurrence.interval}주마다 ${weekArrayString} ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매${this.value.recurrence.interval}주마다 ${weekArrayString} ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매월
                else if (this.value.recurrence.ui_recurringType == 3) {
                    if (this.value.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매월 ${this.value.recurrence.interval}개월마다 ${this.value.recurrence.dayOfMonth}일에 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매월 ${this.value.recurrence.interval}개월마다 ${this.value.recurrence.dayOfMonth}일에 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매년
                else if (this.value.recurrence.ui_recurringType == 4) {
                    if (this.value.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매년 ${this.value.recurrence.monthValue}월 ${this.value.recurrence.dayOfMonth}일마다 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매년 ${this.value.recurrence.monthValue}월 ${this.value.recurrence.dayOfMonth}일마다 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
            }
        }
        if (!this.value.isEWS) {
            this.value.pidLidRecurrencePattern = display
        }
        return display
    }

    // /**
    //  * 반복일정 설정 내용을 표시합니다
    //  */
    //  get getRecurrencePatternDisplay() {

    //     let beautifyStartTime;
    //     let beautifyEndTime;

    //     if(this.value.starttime && this.value.starttime.length >3) {
    //         beautifyStartTime =  this.value.starttime.substr(0, this.value.starttime.length -3);
    //     }
    //     if(this.value.endtime && this.value.endtime.length >3) {
    //         beautifyEndTime = this.value.endtime.substr(0, this.value.endtime.length -3);
    //     }
        
    //     let beautifyEndDate;
    //     if(this.value.recurrence.endDate != null ) {
    //         beautifyEndDate = dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.IEDate(this.value.recurrence.endDate));
    //     }
        
    //     let display: string = '';
        
    //     if(this.value.recurrence.ui_recurringType == 1) {
    //         if(this.value.recurrence.endDate != null)    
    //         {
    //             // 매일 / 종료일 특정 날짜
    //             display = `${beautifyEndDate} 까지 ${this.value.recurrence.interval}일 마다 반복`;
    //         }
    //         else
    //         {
    //             // 매일 / 종료일 기한 없음
    //             display = `${this.value.recurrence.interval}일 마다 반복`;
    //         }
    //     }
    //     //매주
    //     else if(this.value.recurrence.ui_recurringType == 2) {
    //         let weeklist = dateutil.uGetWeekArray([
    //             this.$t('W_Schedule_Sunday').toString(),
    //             this.$t('W_Schedule_Monday').toString(),
    //             this.$t('W_Schedule_Tuesday').toString(),
    //             this.$t('W_Schedule_Wednesday').toString(),
    //             this.$t('W_Schedule_Thursday').toString(),
    //             this.$t('W_Schedule_Friday').toString(),
    //             this.$t('W_Schedule_Saturday').toString(),
    //         ]);
    //         // 반복일정 수정할 때 요일 체크한거 화면에 display
    //         this.showWeekText  = weeklist.filter((x:any) => 
    //             (this.value.recurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)                   
    //         ).map((x) => {return x.text;}).join(',');

    //         //this.showWeekText = weekArrayString;

    //         if(this.value.recurrence.endDate != null)
    //         {
    //             // 매주 / 종료일 특정 날짜
    //             display = `${beautifyEndDate} 까지 ${this.value.recurrence.interval}주마다 ${this.showWeekText} 반복`;
    //         }
    //         else 
    //         {
    //             // 매주 / 종료일 기한 없음
    //             display = `${this.value.recurrence.interval}주마다 ${this.showWeekText} 에 반복`;
    //         }
    //     }
    //     //매월
    //     else if(this.value.recurrence.ui_recurringType == 3) {
    //         if(this.value.recurrence.endDate != null)
    //         {
    //             // 매월 / 종료일 특정 날짜
    //             display = `${beautifyEndDate} 까지 ${this.value.recurrence.interval}개월마다 ${this.value.recurrence.dayOfMonth}일에 반복`;
    //         }
    //         else 
    //         {
    //             // 매월 / 종료일 기한 없음
    //             display = `${this.value.recurrence.interval}개월마다 ${this.value.recurrence.dayOfMonth}일에 반복`;
    //         }
    //     }
    //     //매년
    //     else if(this.value.recurrence.ui_recurringType == 4) {
    //         if(this.value.recurrence.endDate != null)
    //         {
    //             // 매년 / 종료일 특정 날짜
    //             display = `${beautifyEndDate} 까지 매년 ${this.value.recurrence.monthValue}월 ${this.value.recurrence.dayOfMonth}일마다 반복`;
    //         }
    //         else 
    //         {
    //             // 매년 / 종료일 기한 없음
    //             display = `매년 ${this.value.recurrence.monthValue}월 ${this.value.recurrence.dayOfMonth}일마다 반복`;
    //         }
    //     }
  
    //     if (!this.value.isEWS) {
    //         this.value.pidLidRecurrencePattern = display;
    //     }
    //     return display;
    // }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    recurring() {
        this.setCurrentItem(this.value)
        this.$router.push({ path: '/calendar/recurring' , query: { id: this.value.id } })
    }
}
